// F1 Data Visualization Page
import React, { useEffect } from 'react';
import F1HomeComponent from '../../components/f1/F1HomeComponent';
import F1PageTemplate from '../../components/f1/F1PageTemplate';

const F1HomePage = () => {
  useEffect(() => {
    document.title = 'Sydney Ferris - F1 Analytics';
  }, []);
  return (
    <F1PageTemplate
      title="F1 Data Analysis"
      subtitle="Explore comprehensive Formula 1 data across multiple categories"
      summary="Over 70 years of F1 history"

    >
      <F1HomeComponent />
    </F1PageTemplate>
  );
};

export default F1HomePage;
